import React, { Component } from "react";
import MainMenu from "./components/mainMenu";
import SubNavigation from "./components/subNavigation";
import TopBanner from "./components/topBanner";
import ContactForm from "./components/contactForm";
import AnimatedBackground from "./components/animatedBackground";
import Footer from "./components/footer";

export default class Contact extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		document.title = "QwixSkinz || Contact Us";
	}
	componentWillUnmount() {}

	render() {
		return (
			<React.Fragment>
				<MainMenu />

				<TopBanner
					bannerHeight="full"
					title="Contact Us"
					description="Get the QwixSkinz Advantage. Contact us Now!"
					images={["contactUsBanner.jpg"]}
				/>

				<SubNavigation location={this.props.location} refs={this.refs} />

				<div className="qs-b" ref="overview">
					<div className="container block-wrap behind-trees">
						<div className="d-flex flex-row flex-wrap justify-content-between">
							<div className="col-12 col-md-9 content dark">
								<div className="section-title">
									<h1 className="title">Send A Message</h1>
									<ContactForm />
								</div>
							</div>
							<div className="col-12 col-md-3 content dark">
								<div className="section-title">
									<h2 className="title">Our Info</h2>

									<p className="lead">
										Please use the form below to contact Qwixskinz with your
										questions or comments. We are always happy to hear from you.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<Footer />
				<AnimatedBackground />
			</React.Fragment>
		);
	}
}
